import ClientLogger from '~logger/client';
import type { LoggerMessages } from '~logger/constants';
import { LoggerServices } from '~logger/constants';
import { getEnv } from '~shared/utils/env';

export const sendMetricToAPI = (
	metricData: {
		name: string;
		tags: string[];
		value?: number;
		type?: 'gauge' | 'counter';
		raw?: Record<string, unknown>;
	},
	errorMessage: LoggerMessages
) => {
	const sendRequest = async () => {
		try {
			await fetch('/api/metrics', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					...metricData,
					env: getEnv(),
					source: 'webapp',
				}),
			});
		} catch (error) {
			ClientLogger.error(
				LoggerServices.MetricsService,
				errorMessage,
				error as Record<string, unknown>
			);
		}
	};

	if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
		requestIdleCallback(() => {
			return void sendRequest();
		});
		void sendRequest();
	}
};
